import '@cian/peperrors/shared';
import { validate } from './validation.mjs';

function mkSetting(candidate) {
    if (!validate(candidate)) {
        return null;
    }
    return {
        key: candidate.key,
        value: parseValue(candidate.value),
        priority: candidate.priority || 0,
        filter: candidate.filter || {},
    };
}
function mkSettingReliably(candidate) {
    return mkSetting(candidate);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseValue(value) {
    if (typeof value !== 'string') {
        return value;
    }
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return value;
    }
}

export { mkSetting, mkSettingReliably };
//# sourceMappingURL=conversion.mjs.map
